import { NONE, RATING_COLORS, TRating } from 'src/constants/lead/ratings';
import { TSelectItem } from '../components/types';
import { Theme } from '@material-ui/core';
import { TFunction } from 'src/constants/i18next';

/**
 * Maps the ratings to a select item
 *
 * @param {TRating[]} ratings
 */
export const mapRatings = (
    ratings: TRating[],
    t: TFunction,
    theme: Theme
): TSelectItem[] =>
    ratings.map((rating: TRating) => {
        const color =
            rating === NONE
                ? theme.palette.text.primary
                : RATING_COLORS[rating];
        return {
            value: rating,
            label: t(`Status.${rating}`),
            color,
        };
    });
